import { makeAutoObservable } from "mobx";

export default class TimekeepingStore{

    constructor() {
        makeAutoObservable(this);
    }

   
}